const state = {
  editFeature: null,
  editFeatures: [],
  editLayer: null, // not in use yet
  editLayerURL: null,
  infoTool: '', // not in use yet
  customEdit: false,
  bulkEdit: false,
  editorEnabled: false,
  editableLayers: [],
}

const getters = {
  getEditFeature: state => state.editFeature,
  getEditFeatures: state => state.editFeatures,
  getEditLayer: state => state.editLayer,
  getEditLayerURL: state => state.editLayerURL,
  getInfoTool: state => state.infoTool,
  getCustomEdit: state => state.customEdit,
  getBulkEdit: state => state.bulkEdit,
  getEditorEnabled: state => state.editorEnabled,
  getEditableLayers: state => state.editableLayers,
}

const mutations = {
  setEditFeature (state, editFeature) {
    state.editFeature = editFeature
  },
  setEditFeatures (state, editFeatures) {
    state.editFeatures = editFeatures
  },
  setEditLayer (state, editLayer) {
    state.editLayer = editLayer
  },
  setEditLayerURL (state, editLayerURL) {
    state.editLayerURL = editLayerURL
  },
  setInfoTool (state, infoTool) {
    state.infoTool = infoTool
  },
  setCustomEdit (state, customEdit) {
    state.customEdit = customEdit
  },
  setEditorEnabled (state, editorEnabled) {
    state.editorEnabled = editorEnabled
  },
  setEditableLayers (state, editableLayers) {
    state.editableLayers = editableLayers
  },
  setBulkEdit (state, bulkEdit) {
    state.bulkEdit = bulkEdit
  },
}

const actions = {
  setEditFeature ({ commit }, editFeature) {
    commit('setEditFeature', editFeature)
  },
  setEditFeatures ({ commit }, editFeatures) {
    commit('setEditFeatures', editFeatures)
  },
  setEditLayer ({ commit }, editLayer) {
    commit('setEditLayer', editLayer)
  },
  setEditLayerURL ({ commit }, editLayerURL) {
    commit('setEditLayerURL', editLayerURL)
  },
  setInfoTool ({ commit }, infoTool) {
    commit('setInfoTool', infoTool)
  },
  setCustomEdit ({ commit }, customEdit) {
    commit('setCustomEdit', customEdit)
  },
  setEditorEnabled ({ commit }, editorEnabled) {
    commit('setEditorEnabled', editorEnabled)
  },
  setEditableLayers ({ commit }, editableLayers) {
    commit('setEditableLayers', editableLayers)
  },
  setBulkEdit ({ commit }, bulkEdit) {
    commit('setBulkEdit', bulkEdit)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
